// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.megamenu-wrapper {
    padding: 30px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }
  
  .settings-title, .support-title {
    font-size: 16px;
    color: #873EFF;
    padding: 0 16px;
    margin: 0 0 10px 0;
  }
  
  .support-title {
    margin-top: 20px;
    padding-top: 15px;
  }
  .megamenu-wrapper .pl-brand{
    margin-top: 30px;
    padding: 16px;
    background-color: #FFFDEE;
    background-position: right; 
    background-repeat: no-repeat; 
    background-size: cover;    
  }
  
  .megamenu-wrapper ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  
  .megamenu-wrapper li {
    margin: 0;
    list-style: none;
  }
  
  .megamenu-wrapper li.menu-item-active-link > .menu-link {
    color: #873EFF;
    font-weight: 600;
  }
  
  .megamenu-wrapper nav ul,
  .megamenu-wrapper nav li {
    margin: 0;
    padding: 0;
  }
  
  .megamenu-wrapper nav .menu-item {
    position: relative;
  }
  
  .megamenu-wrapper nav .menu-link {
    cursor: pointer;
    color: #000000;
    text-decoration: none;
    display: flex;
    align-items: center;
    padding: 12px 16px;
    transition: all 0.2s ease;
  }
  
  .megamenu-wrapper nav .menu-link:hover {
    color: #873EFF;
    border-radius: 3px;
  }
  
  .megamenu-wrapper nav .menu-link:focus {
    box-shadow: none;
    outline: none;
  }
  
  .megamenu-wrapper nav .menu-icon {
    margin-right: 8px;
    width: 20px;
    height: 20px;
  }
  
  .menu-text {
    flex-grow: 1;
  }
  
  /* Submenu styling */
  .megamenu-wrapper nav .submenu {
    border-left: 3px solid #D1C1FF;
    margin-left: 22px;
    padding-left: 5px;
  }
  
  .megamenu-wrapper nav .submenu .menu-link {
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 400;
  }
  
  .megamenu-wrapper nav .nested-submenu {
    border-left: 3px solid #D1C1FF;
    margin-left: 18px;
    font-weight: 400;
    padding-left: 5px;
  }
  
  .megamenu-wrapper nav .nested-submenu .menu-link {
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 400;
  }
  .megamenu-wrapper nav .nested-submenu .menu-item-active-link {
    background-color: #D1C1FF;
  }
  
  .megamenu-wrapper nav .submenu li.menu-item-active-link > .menu-link {
    color: #873EFF;
  }
  
  .megamenu-wrapper .side-menu > li > .menu-link {
    font-weight: 600;
    font-size: 16px;
  }
  
  /* Active item styling */
  .megamenu-wrapper .menu-link.active {
    color: #873EFF;
    font-weight: 600;
  }
  
  .megamenu-wrapper .submenu .menu-link.active,
  .megamenu-wrapper .nested-menu-title.active {
    border-radius: 3px;
  }
  
  /* Purple highlight for active items */
  .megamenu-wrapper .menu-item-active-link > .menu-link {
    color: #873EFF;
  }



  .megamenu-wrapper .pl-brand h4{
    font-size: 28px;
  }

  .megamenu-wrapper .pl-brand button{
    margin-top: 80px;
    font-size: 16px;
  }`, "",{"version":3,"sources":["webpack://./src/layouts/MegaMenu/MegaMenu.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;;IAEE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA,oBAAoB;EACpB;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,wBAAwB;EACxB;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA,sCAAsC;EACtC;IACE,cAAc;EAChB;;;;EAIA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB","sourcesContent":[".megamenu-wrapper {\n    padding: 30px;\n    background-color: #fff;\n    border-radius: 4px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n  }\n  \n  .settings-title, .support-title {\n    font-size: 16px;\n    color: #873EFF;\n    padding: 0 16px;\n    margin: 0 0 10px 0;\n  }\n  \n  .support-title {\n    margin-top: 20px;\n    padding-top: 15px;\n  }\n  .megamenu-wrapper .pl-brand{\n    margin-top: 30px;\n    padding: 16px;\n    background-color: #FFFDEE;\n    background-position: right; \n    background-repeat: no-repeat; \n    background-size: cover;    \n  }\n  \n  .megamenu-wrapper ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n  }\n  \n  .megamenu-wrapper li {\n    margin: 0;\n    list-style: none;\n  }\n  \n  .megamenu-wrapper li.menu-item-active-link > .menu-link {\n    color: #873EFF;\n    font-weight: 600;\n  }\n  \n  .megamenu-wrapper nav ul,\n  .megamenu-wrapper nav li {\n    margin: 0;\n    padding: 0;\n  }\n  \n  .megamenu-wrapper nav .menu-item {\n    position: relative;\n  }\n  \n  .megamenu-wrapper nav .menu-link {\n    cursor: pointer;\n    color: #000000;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n    transition: all 0.2s ease;\n  }\n  \n  .megamenu-wrapper nav .menu-link:hover {\n    color: #873EFF;\n    border-radius: 3px;\n  }\n  \n  .megamenu-wrapper nav .menu-link:focus {\n    box-shadow: none;\n    outline: none;\n  }\n  \n  .megamenu-wrapper nav .menu-icon {\n    margin-right: 8px;\n    width: 20px;\n    height: 20px;\n  }\n  \n  .menu-text {\n    flex-grow: 1;\n  }\n  \n  /* Submenu styling */\n  .megamenu-wrapper nav .submenu {\n    border-left: 3px solid #D1C1FF;\n    margin-left: 22px;\n    padding-left: 5px;\n  }\n  \n  .megamenu-wrapper nav .submenu .menu-link {\n    padding: 10px 16px;\n    font-size: 14px;\n    font-weight: 400;\n  }\n  \n  .megamenu-wrapper nav .nested-submenu {\n    border-left: 3px solid #D1C1FF;\n    margin-left: 18px;\n    font-weight: 400;\n    padding-left: 5px;\n  }\n  \n  .megamenu-wrapper nav .nested-submenu .menu-link {\n    padding: 8px 16px;\n    font-size: 14px;\n    font-weight: 400;\n  }\n  .megamenu-wrapper nav .nested-submenu .menu-item-active-link {\n    background-color: #D1C1FF;\n  }\n  \n  .megamenu-wrapper nav .submenu li.menu-item-active-link > .menu-link {\n    color: #873EFF;\n  }\n  \n  .megamenu-wrapper .side-menu > li > .menu-link {\n    font-weight: 600;\n    font-size: 16px;\n  }\n  \n  /* Active item styling */\n  .megamenu-wrapper .menu-link.active {\n    color: #873EFF;\n    font-weight: 600;\n  }\n  \n  .megamenu-wrapper .submenu .menu-link.active,\n  .megamenu-wrapper .nested-menu-title.active {\n    border-radius: 3px;\n  }\n  \n  /* Purple highlight for active items */\n  .megamenu-wrapper .menu-item-active-link > .menu-link {\n    color: #873EFF;\n  }\n\n\n\n  .megamenu-wrapper .pl-brand h4{\n    font-size: 28px;\n  }\n\n  .megamenu-wrapper .pl-brand button{\n    margin-top: 80px;\n    font-size: 16px;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
